import { CartResponse } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { ITenderAdd } from '../../../common/interfaces/dtos/IPreTenderAdd';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const preTenderAdd = async (
  transactionId: string,
  lineTenders: ITenderAdd,
): Promise<CartResponse> => {
  const configObject: EmeraldRequestParams = {
    config: {
      url: `/transaction-management/transactions/${transactionId}/tenders/pre-add`,
      method: 'POST',
      data: lineTenders,
    },
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'Checkout - Pre Tender Add' },
  };
  return emeraldRequest<CartResponse>(configObject);
};
